var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageName',{attrs:{"title":"Пассажир","buttons":_vm.buttons}}),(_vm.passengerLoading)?_c('Preloader'):_c('Profile',{attrs:{"user":_vm.passenger,"info":_vm.userInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }